import { getLocations } from "apis";
import { FilterBar, FilterMultiSelect, FilterSingleSelect } from "components/commons";
import { useApi, useMount } from "hooks";
import { allLocationRequest, location } from "mappers";
import React, { useCallback, useMemo } from "react";
import { mapObject, mapObjectsToSelect } from "services";
import lang from "translations";

const InventoryReportFilter = ({
  filterState,
  requestState,
  modifyFilter,
  modifyFilters,
  clearFilter,
  fetchProductReports,
}) => {
  const {
    request: getLocationsRequest,
    loading: loadingLocation,
    mappedData: locations,
  } = useApi({
    api: getLocations,
    isArray: true,
    mapper: location,
  });

  useMount(() => {
    fetchLocations(requestState);
  });

  const fetchLocations = useCallback(
    (requestState) => {
      getLocationsRequest(mapObject({ ...requestState }, allLocationRequest));
    },
    [getLocationsRequest]
  );

  const applyFilterCb = useCallback(
    async (searchKey) => {
      const { requestState } = modifyFilters({ page: 1, searchKey });
      await fetchProductReports(requestState);
    },
    [modifyFilters, fetchProductReports]
  );

  const clearFilterCb = useCallback(async () => {
    const { requestState } = await clearFilter();
    fetchProductReports(requestState);
  }, [clearFilter, fetchProductReports]);

  const locationOptions = useMemo(() => {
    return mapObjectsToSelect(locations, { textKey: "name" });
  }, [locations]);

  const measurementOptions = useMemo(() => {
    return [
      { text: lang.allMeasurements, value: null },
      { text: lang.lowParLevel, value: "lowParLevel" },
      { text: lang.reorderPointReached, value: "reorderPointReached" },
    ];
  }, []);

  return (
    <FilterBar
      className="mb-lg"
      filterState={filterState}
      searchBox={false}
      onClear={clearFilterCb}
      onApply={applyFilterCb}
    >
      <FilterMultiSelect
        id="locations"
        label={lang.outlet}
        allLabel={lang.allLocations}
        emptyLabel={lang.noLocationAvailable}
        disableWhenEmpty={false}
        loading={loadingLocation}
        options={locationOptions}
        value={filterState.locations}
        onChange={(value) => modifyFilter("locations", { value })}
      />
      <FilterSingleSelect
        id="measurement"
        label={lang.measurements}
        options={measurementOptions}
        summaryFallback={lang.allMeasurements}
        value={filterState.measurement}
        onChange={(measurement) => modifyFilter("measurement", { value: measurement })}
      />
    </FilterBar>
  );
};

export default InventoryReportFilter;
